import axios from "axios";
import { BACKEND_URL, API_BASE, apiUrl } from "../config/runtime";

// Same-origin architecture: BACKEND_URL è vuoto in produzione self-hosted,
// axios usa quindi path relativi (/api/...) risolti dal browser.
export const API = API_BASE;
export { apiUrl, BACKEND_URL };

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// Format FastAPI 422 errors safely (don't render objects in React)
export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Errore sconosciuto.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
